import React, { useEffect, useState } from 'react';
import { Page } from '@components/page';
import { LeftOutlined } from '@ant-design/icons';
import { SelectItemsHeader } from './components/select-items-header';
import {
    SelectItemsBody,
    SelectItemsBodyBonification,
} from './components/select-items-body';
import { SelectItemsActions } from './components/select-items-actions';
import { useDispatch, useSelector } from 'react-redux';
import {
    bonificationSelector,
    fetchAvailableItems,
    orderItemsSelector,
    resetAvailableItems,
    updateCampaignItems,
} from '@redux/slices/order';
import { Tabs } from '@components/tabs/styled';
import { useQuery as useQueryHooks } from '@hooks/use-query';
import { Col, Row } from 'antd';
import { Semaphore } from '@components/semaphore';
import { OrderContextProvider } from './context/provider';
import { clearMinOrderState } from '@redux/slices/min-order';
import { translate } from '@components/i18n';
import { AppDispatch } from '@redux/store';
import { updatePaymentCondition } from '@redux/slices/order/select-items';

const { TabPane } = Tabs;

export const Bonification: React.FC = () => {
    const { selectedOrders } = useSelector(bonificationSelector);
    const { order, paymentCondition, selectedMoeda, ...selectItemsState } = useSelector(orderItemsSelector);
    const dispatch = useDispatch<AppDispatch>();
    const query = useQueryHooks();
    const [loading, setLoading] = useState<boolean>(true)

    const fetchPreData = async (): Promise<void> => {
        await Promise.all([
            dispatch(clearMinOrderState()),
            dispatch(resetAvailableItems()),
        ])
    }

    useEffect(() => {
        dispatch(updatePaymentCondition({
            id: "100",
            description: ""
        }))
    }, [])

    useEffect(() => {
        fetchPreData()

        if (order?.customer?.id && order.customer.company && order.paymentCondition?.id === '100') {
            dispatch(fetchAvailableItems({
                paymentConditionId: order.paymentCondition?.id,
                tempItems: selectedOrders?.find(w => w.key === selectItemsState.draftRef).bonificationItems || [],
            })).then((items) => {
                dispatch(updateCampaignItems()).then(() => {
                    setTimeout(() => setLoading(false), 1000)
                })
            })
        }
    }, [order?.customer?.id, order.paymentCondition?.id])

    return (
        <OrderContextProvider>
            <Page
                title={translate('pages.newOrderBonification')}
                greyBackground
                onClickGoBack
                menuIcon={<LeftOutlined />}
            >
                <SelectItemsHeader readOnly bonification />
                <Tabs
                    defaultActiveKey="bonification"
                    style={{ marginLeft: 20 }}
                >
                    <TabPane
                        tab={
                            <Row gutter={10}>
                                <Col>{translate('columns.bonification')}</Col>
                                (<Semaphore order={order} moeda={selectedMoeda} loading={loading} />)
                            </Row>
                        }
                        key={'bonification'}
                    >
                        <SelectItemsBody bonification />
                    </TabPane>
                    {selectedOrders?.map((order, index) => {
                        return (
                            <TabPane
                                tab={
                                    <Row gutter={10}>
                                        <Col>
                                            {query.get('draftRef') ===
                                                `${order.key}`
                                                ? translate(
                                                    'general.actualOrder',
                                                )
                                                : `${translate(
                                                    'columns.order',
                                                )} ${order.key}`}
                                        </Col>

                                        <Semaphore
                                            order={order}
                                            moeda={selectedMoeda}
                                        />
                                    </Row>
                                }
                                key={`tab-${index + 1}`}
                            >
                                <SelectItemsBodyBonification order={order} />
                            </TabPane>
                        );
                    })}
                </Tabs>
                <SelectItemsActions
                    bonification
                    send={
                        selectedOrders?.find(
                            (w) => `${w.key}` === query.get('draftRef'),
                        )?.orderType?.date
                            ? 0
                            : Number(query.get('draftRef'))
                    }
                />
            </Page>
        </OrderContextProvider>
    );
};
